import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const CREATE_EXAM_SECTION_MUTATION: DocumentNode = gql`
	mutation createExamSections($request: BulkCreateExamSectionCatalogRequest!) {
		bulkCreateExamSectionCatalog(request: $request) {
			id
			coverage
			cutScore
			examForm
			high
			mid
			low
			label
			maxScore
			sectionName
		}
	}
`;

export const UPDATE_EXAM_SECTION_MUTATION: DocumentNode = gql`
	mutation updateExamSections($request: BulkUpdateExamSectionCatalogRequest!) {
		bulkUpdateExamSectionCatalog(request: $request) {
			id
			coverage
			cutScore
			examForm
			high
			mid
			low
			label
			maxScore
			sectionName
		}
	}
`;

export const DELETE_EXAM_SECTION_MUTATION: DocumentNode = gql`
	mutation deleteExamSections($request: BulkDeleteExamSectionCatalogRequest!) {
		bulkDeleteExamSectionCatalog(request: $request) {
			id
			coverage
			cutScore
			examForm
			high
			mid
			low
			label
			maxScore
			sectionName
		}
	}
`;

export const BULK_UPSERT_EXAM_SECTION_CATALOG: DocumentNode = gql`
	mutation bulkUpsertExamSectionCatalog($request: BulkUpsertExamSectionCatalogRequest!) {
		bulkUpsertExamSectionCatalog(request: $request) {
			id
		}
	}
`;
